import { render, staticRenderFns } from "./dp-link.vue?vue&type=template&id=32a7e4b2"
import script from "./dp-link.vue?vue&type=script&lang=js"
export * from "./dp-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports